import { createActionType } from 'app/store/utils';

const type = createActionType('preferences');

export const SELECT_WORKBENCH_DATASET_TAB = type('SelectWorkbenchDatasetTab');
export const SELECT_WORKBENCH_PROJECT_TAB = type('SelectWorkbenchProjectTab');
export const SELECT_WORKBENCH_GROUP_TAB = type('SelectWorkbenchGroupTab');
export const SELECT_WORKBENCH_INSPECTOR_TAB = type('SelectWorkbenchInspectorTab');
export const SELECT_PROJECT_INSPECTOR_TAB = type('SelectProjectInspectorTab');
export const TOGGLE_MAXIMIZED_PREVIEW = type('ToggleMazimizedPreview');
export const TOGGLE_AUTORUN_PREVIEW = type('ToggleAutorunPreview');
